import TableView from "../../ReusableComponents/TableView/TableView"
import { useState,useEffect } from "react";
import Popup from "../../ReusableFunctions/Popup";
import { getCrmleadsLogByLeadId } from "../../apis/BhuMeetTeams/Crm/leadsCallHistory";

export const LeadsCallHistoryTable = ({state,openModel})=>{
    const [callHistory, setcallHistory] = useState([]);
    const [selectedCallHistory,setSelected] = useState(null)
    const [selectedCallHistoryrecord,setselectedCallHistoryrecord] = useState(null)
    const [loading,setLoading] = useState(false)
    const [filter,setFilter] = useState()

    
    useEffect(()=>{
        // console.log(state)
        getAllCallingHistory()
    },[filter,])

    


    const getAllCallingHistory = async () => {
        // console.log(campids)
        setLoading(true)
        getCrmleadsLogByLeadId(state.lead_id,filter).then(res => {
            // console.log(res)
            
            setcallHistory(res)
            setLoading(false)
        }).catch(err=>{
            console.log(err)
            setLoading(false)
        })
    }



    return (
        <>
        
        
        <TableView marginBottom={"15px"}
                    // showSrNo
                    loadingHeight={"400px"}
                    isLoading={loading}

                    onStateChange={(state)=>{
                        // console.log(state)
                        const {orderBy,orderType} = state
                        setFilter((prev)=>({...prev,orderBy,orderType}))
                        
                    }}

                    onClickRow={(row) => {

                        setselectedCallHistoryrecord(row)
              
                      }}
                    
                    columns={[
                        { Header: "Call By", accessor: "call_by", width: "15%" },
                        { Header:"Request Note", accessor:"note",width:"17%"},
                        { Header:"Call Duration", accessor:"duration",width:"9%"},
                        { Header:"Campaign Name" ,accessor:"campaign_name",width:"12%",isSortable: true},
                        { Header: "Status", accessor: "status", width: "10%" },
                        { Header: "Date", accessor: "created", isDate: true, width: "12%",isSortable: true },
                    ]}
                    count={0}
                    pageSize={15}
                    pageNumber={1}
                    data={callHistory}
                    styles={{maxHeight:"324px"}}
                    tableContainerHeight={"auto"}
                    hidePagination={false}
                    headerStyle={{ zIndex: 1 }}

                    
                    activities={openModel ? {  onClickEdit: (e)=>{
                        // console.log(e)
                        if((!e.note)){
                            
                            setSelected(e)
                            openModel(e.campid)


                        }else{
                            Popup.alert("ERROR","This History is already Created , You cannot edit","ERROR")
                        }
                        

                    }, canEdit: false } : null}

                />
                
                </>
    )

}